import { isEqual } from 'lodash';
import { createParser } from 'nuqs';

import { CargoOption } from '@/types';

export const parseAsCargoOption = createParser<CargoOption>({
  parse(value) {
    const cargo = JSON.parse(value);
    return { ...cargo };
  },
  serialize(value) {
    return JSON.stringify(value);
  },
  eq: isEqual,
});
